import React, { Component } from "react";
import T from "prop-types";
import { Map } from "immutable";
import Notes from "MODULES/shared/components/Notes";
import Attachments from "MODULES/shared/components/Attachments";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import { ATTACHMENT_TYPES } from "MODULES/SalesOrders/constants";
import { toggleSwitch } from "MODULES/shared/decorators";
import { SpecialInstructions } from "MODULES/SalesOrders/components/shared/SpecialInstructions";
import { Col } from "react-bootstrap";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { RmaRequestModal } from "./LineItems/RmaRequest";
import LineItems from "./LineItems";

export class Body extends Component {
  state = {
    lineItem: null
  };

  openRma = lineItem => {
    this.setState({ lineItem });
    this.props.open();
  };

  render() {
    const { creatingRmaRequest, salesOrder, close } = this.props;
    const { lineItem } = this.state;

    return (
      <div className="col-md-9">
        <LineItems
          salesOrder={salesOrder}
          openRma={this.openRma}
          company={salesOrder.company}
        />
        <FormRow>
          <Col md={6}>
            <Notes
              resource={Map(salesOrder)}
              resourceType={resourceTypes.salesOrder}
            />
          </Col>
          <Col md={6}>
            <Notes
              headerLabel="Accounting Notes"
              resource={Map(salesOrder)}
              resourceType={resourceTypes.salesOrder}
              notesType="accounting"
            />
          </Col>
        </FormRow>

        <SpecialInstructions
          resource={Map(salesOrder)}
          resourceType={resourceTypes.salesOrder}
        />
        <Attachments
          attachmentTypes={ATTACHMENT_TYPES}
          resource={Map(salesOrder)}
          resourceType={resourceTypes.salesOrder}
          resourceKey="company"
          multiple
        />
        <RmaRequestModal
          open={creatingRmaRequest}
          close={close}
          lineItem={lineItem}
        />
      </div>
    );
  }
}

Body.propTypes = {
  creatingRmaRequest: T.bool.isRequired,
  salesOrder: T.shape({}).isRequired,
  open: T.func,
  close: T.func
};

export default toggleSwitch("creatingRmaRequest")(Body);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/Body.jsx